!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self).Apxor = t();
}(this, function () {
  "use strict";

  function e(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function t(e, t) {
    for (var n = 0; n < t.length; n++) {
      var i = t[n];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }

  function n(e, n, i) {
    return n && t(e.prototype, n), i && t(e, i), e;
  }

  function i(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function r(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {},
          r = Object.keys(n);
      "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
        return Object.getOwnPropertyDescriptor(n, e).enumerable;
      }))), r.forEach(function (t) {
        i(e, t, n[t]);
      });
    }

    return e;
  }

  function o(e) {
    return function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }
    }(e) || function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  var s = {
    enable: !0,
    api_root: "https://server.apxor.com/v2/api",
    auto_track_events: ["click", "submit"],
    cookie_expiration: 730,
    name: "",
    domain: "",
    cookie_prefix: "_apx_",
    idle_time_out: 3600
  },
      a = {
    debug: !1,
    honorDNT: !1,
    idle_time_out: 3600,
    client_id: null,
    session_id: null,
    plugins: [],
    version: "ALL",
    events_upload_time: -1,
    retry_time: -1
  },
      u = "Opera Mini",
      c = "Opera",
      d = "BlackBerry",
      f = "Internet Explorer Mobile",
      l = "Microsoft Edge",
      h = "Facebook Mobile",
      g = "Chrome",
      v = "Chrome iOS",
      p = "UC Browser",
      _ = "Firefox iOS",
      m = "Mobile Safari",
      w = "Safari",
      x = "Android Mobile",
      y = "Konqueror",
      S = "Firefox",
      b = "Internet Explorer",
      k = "Mozilla",
      O = function O(e) {
    return e + "id";
  },
      A = "_apx_ua",
      I = "_apx_lEt",
      N = "_apx_sId",
      E = "_apx_use",
      P = "_apx_scnm",
      J = function J(e) {
    return e + "in";
  },
      C = function C(e) {
    return e + "ver";
  },
      M = function M(e) {
    return e + "lbgt";
  },
      T = "visible",
      F = "APX_PAGE_OPENED",
      D = "apx_app_opened",
      U = "USER_EVENT",
      j = "SYSTEM_EVENT",
      L = "NAVIGATION_EVENT",
      X = "APP_EVENT",
      q = function t() {
    e(this, t);
  };

  i(q, "isCookieAvailable", function () {
    try {
      var e = new Date().getTime() + 864e5;
      document.cookie = "cookie_set=cookie_value; expires=" + e;

      for (var t = document.cookie.split(";"), n = 0; n < t.length; n++) {
        if (-1 !== t[n].indexOf("cookie_set")) return document.cookie = "cookie_set=cookie_value; expires=Thu, 01 Jan 1970 00:00:01 GMT;", !0;
      }

      return !1;
    } catch (e) {
      return !1;
    }
  }), i(q, "get", function (e) {
    if (window.document) for (var t = e + "=", n = window.document.cookie.split(";"), i = 0; i < n.length; i++) {
      for (var r = n[i]; " " === r.charAt(0);) {
        r = r.substring(1, r.length);
      }

      if (0 === r.indexOf(t)) return decodeURIComponent(r.substring(t.length, r.length));
    }
    return null;
  });

  var G,
      Q,
      B,
      Z,
      V = function V(e) {
    return void 0 === e;
  },
      R = function R(e) {
    return null === e;
  },
      W = function W(e) {
    return void 0 !== e && !R(e);
  },
      K = function K(e) {
    return "function" == typeof e;
  },
      Y = function Y(e) {
    return "string" == typeof e;
  },
      H = function H(e) {
    return "boolean" == typeof e;
  },
      z = function z(e) {
    return W(e) && !R(e) && !isNaN(e);
  },
      $ = function $() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = arguments.length > 1 ? arguments[1] : void 0;

    if (null != t && K(t)) {
      var n = e.document;
      "loading" !== n.readyState ? t() : K(n.addEventListener) ? n.addEventListener("DOMContentLoaded", t) : K(e.attachEvent) && e.attachEvent("onreadystatechange", function (e) {
        "loading" !== n.readyState && t(e);
      });
    }
  },
      ee = function ee() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {
      return null;
    };
    K(t) && (e.addEventListener("pagehide", function (e) {
      return t(e), "";
    }), e.addEventListener("beforeunload", function (e) {
      return t(e), "";
    }), e.addEventListener("onunload", function (e) {
      return t(e), "";
    }));
  },
      te = function te() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {
      return null;
    };
    K(t) && (e.removeEventListener("pagehide", t), e.removeEventListener("beforeunload", t), e.removeEventListener("onunload", t));
  },
      ne = function ne(e, t, n) {
    var i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    K(e.addEventListener) ? e.addEventListener(t, n, i) : K(e.attachEvent) ? e.attachEvent(t, n) : e["on" + t] = n;
  },
      ie = function ie(e, t, n) {
    K(e.removeEventListener) ? e.removeEventListener(t, n) : K(e.detachEvent) ? e.detachEvent(t, n) : e["on" + t] = n;
  },
      re = function re(e) {
    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
        n = function n(e) {
      return e < 10 ? "0" + e : e;
    },
        i = e.getFullYear() + "-" + n(e.getMonth() + 1) + "-" + n(e.getDate()) + "T" + n(e.getHours()) + ":" + n(e.getMinutes()) + ":" + n(e.getSeconds());

    return t ? i + e.toTimeString().split(" ")[1].replace(/GMT([+|-])(\d{2})(\d{2})/, "$1$2:$3") : i;
  },
      oe = function oe() {
    return Date.now();
  },
      se = function e() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
    return t ? (t ^ 16 * Math.random() >> t / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, e);
  },
      ae = function ae(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        n = !1;
    return setTimeout(function () {
      n || (n = !0, e());
    }, t);
  },
      ue = function ue() {
    var e,
        t,
        n,
        o,
        s,
        a,
        O = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        A = O.navigator,
        I = (A = void 0 === A ? {} : A).userAgent,
        N = void 0 === I ? "" : I,
        E = A.vendor,
        P = void 0 === E ? "" : E,
        J = u,
        C = c,
        M = d,
        T = f,
        F = l,
        D = h,
        U = g,
        j = v,
        L = p,
        X = _,
        q = m,
        G = w,
        Q = x,
        B = y,
        Z = S,
        V = b,
        R = k,
        W = function () {
      switch (!0) {
        case N.includes(" OPR/"):
          return N.includes("Mini") ? J : C;

        case /(BlackBerry|PlayBook|BB10)/i.test(N):
          return M;

        case N.includes("IEMobile") || N.includes("WPDesktop"):
          return T;

        case N.includes("FBIOS"):
          return D;

        case N.includes("Chrome"):
          return U;

        case N.includes("CriOS"):
          return j;

        case N.includes("Edge"):
          return F;

        case N.includes("UCWEB") || N.includes("UCBrowser"):
          return L;

        case N.includes("FxiOS"):
          return X;

        case P.includes("Apple"):
          return N.includes("Mobile") ? q : G;

        case N.includes("Android"):
          return Q;

        case N.includes("Konqueror"):
          return B;

        case N.includes("Firefox"):
          return Z;

        case N.includes("MSIE") || N.includes("Trident/"):
          return V;

        case N.includes("Gecko"):
          return R;

        default:
          return "";
      }
    }(),
        K = function () {
      var e,
          t = (e = {}, i(e, T, /rv:(\d+(\.\d+)?)/), i(e, F, /Edge\/(\d+(\.\d+)?)/), i(e, U, /Chrome\/(\d+(\.\d+)?)/), i(e, j, /CriOS\/(\d+(\.\d+)?)/), i(e, L, /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/), i(e, G, /Version\/(\d+(\.\d+)?)/), i(e, q, /Version\/(\d+(\.\d+)?)/), i(e, C, /(Opera|OPR)\/(\d+(\.\d+)?)/), i(e, Z, /Firefox\/(\d+(\.\d+)?)/), i(e, X, /FxiOS\/(\d+(\.\d+)?)/), i(e, B, /Konqueror:(\d+(\.\d+)?)/), i(e, M, /BlackBerry (\d+(\.\d+)?)/), i(e, Q, /android\s(\d+(\.\d+)?)/), i(e, V, /(rv:|MSIE )(\d+(\.\d+)?)/), i(e, R, /rv:(\d+(\.\d+)?)/), e)[W];
      if (void 0 === t) return null;
      var n = N.match(t);
      return n ? parseFloat(n[n.length - 2]) : null;
    }(),
        Y = function () {
      switch (!0) {
        case /Windows Phone/i.test(N) || /WPDesktop/.test(N):
          return "Windows Phone";

        case /iPad/.test(N):
          return "iPad";

        case /iPod/.test(N):
          return "iPod Touch";

        case /iPhone/.test(N):
          return "iPhone";

        case /(BlackBerry|PlayBook|BB10)/i.test(N):
          return "BlackBerry";

        case /Android/.test(N):
          return "Android";

        default:
          return "Desktop";
      }
    }(),
        H = function () {
      switch (!0) {
        case /Windows/i.test(N):
          return /Phone/.test(N) || /WPDesktop/.test(N) ? "Windows Phone" : "Windows";

        case /(iPhone|iPad|iPod)/.test(N):
          return "iOS";

        case /Android/.test(N):
          return "Android";

        case /(BlackBerry|PlayBook|BB10)/i.test(N):
          return "BlackBerry";

        case /Mac/i.test(N):
          return "Mac OS X";

        case /Linux/.test(N):
          return "Linux";

        case /CrOS/.test(N):
          return "Chrome OS";

        default:
          return "";
      }
    }();

    return r({}, (e = O.screen, t = (e = void 0 === e ? {
      width: 0,
      height: 0
    } : e).height, n = e.width, o = O.devicePixelRatio, s = void 0 === o ? 1 : o, {
      dimensions: {
        width: n,
        height: t
      },
      dimensions_in_pixels: {
        width: (a = function a(e) {
          var t = Math.round(e) * s,
              n = t % 10;
          return t + (n > 0 ? 10 : 0) - n;
        })(n),
        height: a(t)
      },
      dpi: s.toString()
    }), {
      device: Y,
      browser_version: K,
      browser: W,
      os: H
    });
  },
      ce = function ce() {
    var e,
        t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.navigator,
        o = (r = void 0 === r ? {} : r).language,
        s = n.browser_version,
        a = n.browser,
        u = q.isCookieAvailable();
    return i(e = {}, "apx_browser", a), i(e, "apx_browser_version", a + "_" + s), i(e, "apx_language", o), i(e, "apx_cookies_supported", u), e;
  },
      de = function de() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.navigator,
        n = (t = void 0 === t ? {} : t).connection,
        i = (n = void 0 === n ? {} : n).effectiveType,
        r = n.saveData,
        o = t.platform,
        s = t.webdriver,
        a = e.document.referrer,
        u = {};
    return i && (u.apx_network = i), r && (u.apx_data_save_mode = r), o && (u.apx_platform = o), W(s) && s && (u.apx_automation = s), W(a) && a.length > 0 ? u.apx_referrer = a : u.apx_referrer = "direct", u;
  },
      fe = function fe(e) {
    var t = e.document.querySelector("title");
    return W(t) && W(t.innerText) ? t.innerText : "Unknown";
  },
      le = function le(e) {
    return z(e) ? he(e / 1e3) : e;
  },
      he = function he(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 3;
    if (!z(e) || !z(t)) return e;
    if (t % 1 != 0) return e;
    var n = Math.pow(10, t);
    return Math.round(e * n) / n;
  },
      ge = function ge() {
    var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).location,
        t = (e = void 0 === e ? {} : e).protocol,
        n = e.host;
    return "file:" === t || "localhost" === n ? "development" : "production";
  },
      ve = function ve(e) {
    return e instanceof Object;
  },
      pe = function pe() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;

    if (ve(e)) {
      var n = {};
      return Object.keys(r({}, e)).forEach(function (i) {
        var r = e[i],
            o = i;
        Y(i) || (o = JSON.stringify(i)), H(r) || z(r) ? we(n, o, r) : Y(r) ? n[o] = xe(r) : Array.isArray(r) ? _e(n, o, r, t) : ve(r) && me(n, i, r, t - 1);
      }), n;
    }

    return {};
  },
      _e = function _e(e, t, n) {
    var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
    if (i <= 0) we(e, t, JSON.stringify(n));else if (Array.isArray(n)) {
      var r = n;

      if (r.length > 0) {
        var o = "";
        H(r[0]) ? o = "b" : Y(r[0]) ? o = "s" : z(r[0]) ? o = "n" : Array.isArray(r[0]) ? o = "a" : ve(r[0]) && (o = "o");
        var s = r.length;
        if ("" === o) return void we(e, t, JSON.stringify(n));

        for (var a = 1; a < s; a++) {
          if ("s" === o) {
            if (!Y(r[a])) return void we(e, t, JSON.stringify(n));
          } else if ("b" === o) {
            if (!H(r[a])) return void we(e, t, JSON.stringify(n));
          } else if ("n" === o) {
            if (!z(r[a])) return void we(e, t, JSON.stringify(n));
          } else if ("a" === o) {
            if (!Array.isArray(r[a])) return void we(e, t, JSON.stringify(n));
          } else if ("o" === o && !ve(r[a])) return void we(e, t, JSON.stringify(n));
        }

        if ("o" === o) {
          if (i - 1 <= 0) {
            for (var u = [], c = 0; c < s; c++) {
              u.push(JSON.stringify(r[c]));
            }

            we(e, t, u);
          } else for (var d = 0; d < s; d++) {
            me(e, t, r[d], i - 1);
          }
        } else if ("a" === o) for (var f = 0; f < s; f++) {
          we(e, t, JSON.stringify(r[f]));
        } else for (var l = 0; l < s; l++) {
          we(e, t, r[l]);
        }
      } else we(e, t, []);
    }
  },
      me = function e(t, n, i) {
    var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
    o <= 0 ? we(t, n, JSON.stringify(i)) : Object.keys(r({}, i)).forEach(function (r) {
      var s = n + "_" + r,
          a = i[r];
      W(a) && (Array.isArray(a) ? _e(t, s, a, o - 1) : ve(a) ? e(t, s, a, o - 1) : we(t, s, a));
    });
  },
      we = function we(e, t, n) {
    if (W(t) && W(n)) if (e.hasOwnProperty(t)) {
      var i = e[t],
          r = i;
      Array.isArray(i) || ((z(i) && !z(n) || H(i) && !H(n) || Y(i) && !Y(n) || ve(i) && !ve(n)) && (Y(i) || (i = JSON.stringify(i)), Y(n) || (n = JSON.stringify(n))), (r = []).push(i)), r.push(n), e[t] = r;
    } else e[t] = n;
  },
      xe = function xe(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 120;
    return Y(e) ? e.length > t ? e.slice(0, t) + "..." : e : void 0;
  },
      ye = function ye(e) {
    if (!W(e) && !Y(e)) return !1;
    var t = e.replace(/(?:\r\n|\r|\n)/g, "").trim(),
        n = t.length;
    if ("{" === t[0] && "}" === t[n - 1] || "[" === t[0] && "]" === t[n - 1]) try {
      return JSON.parse(t), !0;
    } catch (e) {}
    return !1;
  },
      Se = function Se(e, t) {
    return W(t) ? function (e) {
      var t,
          n,
          i,
          r,
          o,
          s,
          a,
          u,
          c,
          d = 0,
          f = "";
      if (!e) return e;

      do {
        t = e[d++], n = e[d++], i = e[d++], r = (u = t << 16 | n << 8 | i) >> 18 & 63, o = u >> 12 & 63, s = u >> 6 & 63, a = 63 & u, f += ke.charAt(r) + ke.charAt(o) + ke.charAt(s) + ke.charAt(a);
      } while (d < e.length);

      return ((c = e.length % 3) ? f.slice(0, c - 3) : f) + "===".slice(c || 3);
    }(t = function (e, t) {
      return Array.from(t).map(function (t, n) {
        return t.charCodeAt(0) ^ Oe(e, n);
      });
    }(e, t)) : null;
  },
      be = function be(e, t) {
    return function (e, t) {
      return Array.from(t).map(function (t, n) {
        return String.fromCharCode(t ^ Oe(e, n));
      }).join("");
    }(e, t = function (e) {
      var t,
          n,
          i,
          r,
          o,
          s,
          a,
          u,
          c = 0,
          d = [];
      if (!e) return e;
      e += "";

      do {
        r = ke.indexOf(e.charAt(c++)), o = ke.indexOf(e.charAt(c++)), s = ke.indexOf(e.charAt(c++)), a = ke.indexOf(e.charAt(c++)), t = (u = r << 18 | o << 12 | s << 6 | a) >> 16 & 255, n = u >> 8 & 255, i = 255 & u, d.push(t), 64 !== s && (d.push(n), 64 !== a && d.push(i));
      } while (c < e.length);

      return d;
    }(t));
  },
      ke = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

  function Oe(e, t) {
    return e.charCodeAt(Math.floor(t % e.length));
  }

  String.prototype.includes || (String.prototype.includes = function () {
    return -1 !== String.prototype.indexOf.apply(this, arguments);
  }), Array.from || (Array.from = (G = Object.prototype.toString, Q = function Q(e) {
    return "function" == typeof e || "[object Function]" === G.call(e);
  }, B = Math.pow(2, 53) - 1, Z = function Z(e) {
    var t = function (e) {
      var t = Number(e);
      return isNaN(t) ? 0 : 0 !== t && isFinite(t) ? (t > 0 ? 1 : -1) * Math.floor(Math.abs(t)) : t;
    }(e);

    return Math.min(Math.max(t, 0), B);
  }, function (e) {
    var t = Object(e);
    if (null == e) throw new TypeError("Array.from requires an array-like object - not null or undefined");
    var n,
        i = arguments.length > 1 ? arguments[1] : void 0;

    if (void 0 !== i) {
      if (!Q(i)) throw new TypeError("Array.from: when provided, the second argument must be a function");
      arguments.length > 2 && (n = arguments[2]);
    }

    for (var r, o = Z(t.length), s = Q(this) ? Object(new this(o)) : new Array(o), a = 0; a < o;) {
      r = t[a], s[a] = i ? void 0 === n ? i(r, a) : i.call(n, r, a) : r, a += 1;
    }

    return s.length = o, s;
  })), Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", {
    value: function value(e, t) {
      if (null == this) throw new TypeError('"this" is null or not defined');
      var n = Object(this),
          i = n.length >>> 0;
      if (0 === i) return !1;
      var r,
          o,
          s = 0 | t,
          a = Math.max(s >= 0 ? s : i - Math.abs(s), 0);

      for (; a < i;) {
        if ((r = n[a]) === (o = e) || "number" == typeof r && "number" == typeof o && isNaN(r) && isNaN(o)) return !0;
        a++;
      }

      return !1;
    }
  });

  var Ae = ["log", "debug", "info", "warn", "error"],
      Ie = Ae.reduce(function (e, t) {
    return e[t] = t, e;
  }, {}),
      Ne = function Ne(e) {
    if (V(e)) {
      var t = function t() {
        return null;
      };

      e = Ae.reduce(function (e, n) {
        return e[n] = t, e;
      }, {});
    }

    return e;
  },
      Ee = function () {
    function t() {
      e(this, t);
    }

    return n(t, null, [{
      key: "enabled",
      set: function set(e) {
        t._enabled = e;
      }
    }, {
      key: "level",
      set: function set(e) {
        t._level = e;
      }
    }, {
      key: "console",
      set: function set(e) {
        t._console = Ne(e);
      }
    }]), t;
  }();

  i(Ee, "_console", Ne()), i(Ee, "_enabled", !1), i(Ee, "_level", "error"), i(Ee, "_render", function (e) {
    return function () {
      var t = Ae.indexOf(e) >= Ae.indexOf(Ee._level);

      if (Ee._enabled && t) {
        for (var n = arguments.length, i = new Array(n), r = 0; r < n; r++) {
          i[r] = arguments[r];
        }

        Ee._console[e].apply(Ee._console, i);
      }
    };
  }), i(Ee, "log", Ee._render(Ie.log)), i(Ee, "info", Ee._render(Ie.info)), i(Ee, "debug", Ee._render(Ie.debug)), i(Ee, "warn", Ee._render(Ie.warn)), i(Ee, "error", Ee._render(Ie.error));

  var Pe = function t() {
    var n = this;
    e(this, t), i(this, "OmvQ", function (e, t) {
      if (n._listeners.hasOwnProperty(e)) for (var i = n._listeners[e], r = 0; r < i.length; r++) {
        (0, i[r])(t);
      }
    }), i(this, "registerForEvent", function (e, t) {
      var i;
      K(t) && ((i = n._listeners.type ? n._listeners[e] : []).push(t), n._listeners[e] = i);
    }), i(this, "unregisterFromEvent", function (e, t) {
      if (n._listeners[e]) {
        for (var i = n._listeners[e], r = [], o = 0; o < i.length; o++) {
          var s = i[o];
          s !== t && r.push(s);
        }

        n._listeners[e] = r;
      }
    }), this._listeners = {};
  },
      Je = function Je(e, t, n, i) {
    var r = e.x,
        o = e.y,
        s = e.type,
        a = e.target,
        u = a.innerText,
        c = a.href,
        d = void 0 === c ? "" : c,
        f = a.nodeName;
    n = z(n) ? he(n) : 0, i = z(i) ? he(i) : n;
    var l = {
      event_type: s.toUpperCase(),
      event_view_text: xe(u),
      start_time: n,
      navigation_id: t,
      is_multi_touch: !1,
      began: [{
        x: r,
        y: o,
        time: n
      }],
      moved: [],
      ended: [],
      end_time: i
    };
    return "click" === s && "a" === f && (l.href = d), l;
  },
      Ce = function Ce(e, t) {
    return {
      name: e === T ? "FOREGROUND" : "BACKGROUND",
      time: z(t) ? he(t) : 0
    };
  },
      Me = function Me(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = arguments.length > 2 ? arguments[2] : void 0,
        i = arguments.length > 3 ? arguments[3] : void 0;
    if (Y(e) && ve(t)) return {
      name: e,
      additional_info: t,
      category: W(n) && Y(n) ? n : void 0,
      time: z(i) ? he(i) : 0
    };
  },
      Te = function Te(e, t, n, i, r) {
    return {
      app_name: e,
      app_version: r = W(r) ? r : "ALL",
      bundle_id: t,
      installation_time: n,
      app_mode: i
    };
  },
      Fe = function Fe(e, t, n, i, r, o) {
    return {
      id: e,
      hardware_model: t,
      dimensions: n,
      os_version: i,
      platform: "web",
      dpi: r,
      dimensions_in_pixels: o
    };
  },
      De = function De(e, t, n) {
    var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
    return {
      navigation_id: e,
      name: t,
      duration: z(n) ? he(n) : 0,
      transition_time: z(i) ? he(i) : 0
    };
  },
      Ue = {
    navigation_events: [],
    app_events: [],
    system_events: [],
    user_events: [],
    chunk_attributes: {},
    user_attributes: {},
    session_attributes: {}
  },
      je = function t() {
    var n = this,
        r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    e(this, t), i(this, "sZUP", function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          i = arguments.length > 2 ? arguments[2] : void 0,
          r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
          o = n.window,
          s = (o.fetch, o.XMLHttpRequest);
      Ee.debug("POST request with data"), s ? n.hUZB(e, t, i, r) : (Ee.error("Unknown browser..."), i(403, "Unknown")), Ee.debug("sent request to server");
    }), i(this, "get", function (e, t) {
      var i = n.window,
          r = i.fetch,
          o = i.XMLHttpRequest;
      if (r) r(e).then(function (e) {
        try {
          if (e.ok) return e.json();
        } catch (e) {}

        return null;
      }).then(function (e) {
        W(e) ? t(200, e) : t(500, {});
      }).catch(function (e) {
        return t(500, e);
      });else if (o) {
        var s = new o();
        s.open("GET", n.url, !0), s.onreadystatechange = function () {
          4 === s.readyState && t(s.status, s.responseText);
        }, s.send();
      } else Ee.error("Unknown browser..."), t(403, "Unknown");
      Ee.debug("sent request to server");
    }), i(this, "hUZB", function (e, t, i, r) {
      var o = new XMLHttpRequest();
      o.onerror = function () {
        i(500, null);
      }, o.open("POST", e, r), o.setRequestHeader("Content-Type", "application/json; charset=UTF-8"), o.onreadystatechange = function () {
        if (4 === o.readyState) {
          var r = o.responseText,
              s = r.match(/Failed to execute 'send' on 'XMLHttpRequest'/);
          if (!(R(s) || V(s) || R(s[0]) || V(s[0]) || "Failed to execute 'send' on 'XMLHttpRequest'" !== s[0])) return void n.hUZB(e, t, i, !0);

          try {
            r = JSON.parse(r);
          } catch (e) {}

          i(o.status, r);
        }
      };

      try {
        o.send(JSON.stringify(t));
      } catch (e) {
        i(500, e);
      }
    }), this.window = r;
  },
      Le = function t(n, r) {
    var o = this,
        s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    e(this, t), i(this, "bCiy", function (e) {
      return o.api_root + e + "?appId=" + o.siteId;
    }), i(this, "cdaS", function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function () {
        return null;
      },
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {
        return null;
      };
      return function (n, i) {
        Ee.debug("XHR Response: [".concat(n, "]")), n < 400 ? i && "APXOR_STATUS_SUCCESS" === i.apxor_status ? e(i.details) : 200 === n ? e(i) : t(n, i) : t && K(t) && t(n, i);
      };
    }), i(this, "Ypno", function (e, t, n) {
      o.request.sZUP(o.configAPI, e, o.cdaS(t, n));
    }), i(this, "nHOx", function (e, t, n) {
      var i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
      Ee.debug("Posting chunk"), o.request.sZUP(o.chunksAPI, e, o.cdaS(t, n), i);
    }), i(this, "nsQl", function (e, t, n) {
      o.request.get(e, o.cdaS(t, n));
    }), this.request = new je(s), this.api_root = r.api_root, this.siteId = n, this.configAPI = this.bCiy("/web-config"), this.chunksAPI = this.bCiy("/chunks");
  },
      Xe = function t(n) {
    var r = this,
        o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
    e(this, t), i(this, "wpkU", -1), i(this, "tLRd", 0), i(this, "wqDl", function () {
      return r.tLRd;
    }), i(this, "yQwL", function () {
      return r.wpkU;
    }), i(this, "udPJ", function () {
      r.wpkU = -1, r.tLRd = 0;
    }), i(this, "zdrV", function (e) {
      if ("FOREGROUND" === e.name) {
        if (-1 !== r.wpkU) {
          var t = Math.round(le(Date.now() - r.wpkU));
          r.tLRd += t;
          var n = We.getInstance().getFromStorage(N);

          if (W(n) && We.getInstance().getSessionId() !== n) {
            We.getInstance().emdp();
            var i = We.getInstance().GSAX(),
                o = i.total_duration,
                s = i.duration;
            r.tLRd = o > s ? o - s : 0;
          }
        }
      } else r.wpkU = Date.now(), We.getInstance().persistToStorage(M(r._cookiePrefix), r.wpkU);
    });
    var s = n.cookie_prefix;
    this._cookiePrefix = s, We.getInstance().registerForEvent(j, this._onSystemEvent), this.tLRd = o, We.getInstance().persistToStorage(M(this._cookiePrefix), this.wpkU);
  },
      qe = function t(n) {
    var r = this;
    e(this, t), i(this, "GGTP", function (e) {
      var t = !0;

      try {
        window[e] ? (window[e].setItem("_apx_", "apx"), "apx" !== window[e].getItem("_apx_") && (t = !1), window[e].removeItem("_apx_")) : t = !1;
      } catch (e) {
        t = !1;
      }

      return t || Ee.error("localStorage not supported..!"), t;
    }), i(this, "HMcn", function (e) {
      Ee.error("".concat(r.storageType, " Error: "), e);
    }), i(this, "get", function (e) {
      try {
        return r.storage.getItem(e);
      } catch (e) {}

      return null;
    }), i(this, "gWAP", function (e) {
      try {
        return JSON.parse(r.storage.getItem(e));
      } catch (e) {}

      return null;
    }), i(this, "set", function (e, t) {
      try {
        r.storage.setItem(e, t);
      } catch (e) {}
    }), i(this, "DJsW", function (e) {
      try {
        r.storage.removeItem(e);
      } catch (e) {}
    }), i(this, "clear", function (e) {
      try {
        var t = e.cookie_prefix;
        r.storage.removeItem("_apx_config"), r.storage.removeItem(A), r.storage.removeItem(I), r.storage.removeItem(N), r.storage.removeItem("_apx_sc"), r.storage.removeItem(O(t)), r.storage.removeItem(J(t)), r.storage.removeItem(C(t)), r.storage.removeItem(M(t));
      } catch (e) {}
    }), this.GGTP(n) ? (this.storage = window[n], this.storageType = n) : (this.storageType = n, this.storage = {
      length: 0,
      getItem: function getItem(e) {},
      setItem: function setItem(e, t) {},
      removeItem: function removeItem(e) {},
      clear: function clear() {},
      get: function get(e) {},
      set: function set(e, t) {},
      remove: function remove(e) {},
      getParsed: function getParsed(e) {}
    });
  };

  var Ge = function t(n) {
    var o = this;
    e(this, t), i(this, "LsCt", ""), i(this, "hkPh", function (e, t) {
      if (t) Array.isArray(e) || (e = [e]), o.storage.set("_apx_od", Se(o.LsCt, JSON.stringify(e)));else {
        var n = o.kkGE();
        W(n) && o.storage.set("_apx_od", Se(o.LsCt, JSON.stringify([].concat(n, e))));
      }
    }), i(this, "kkGE", function () {
      var e = o.storage.get("_apx_od");
      if (W(e)) if (ye(e)) try {
        e = JSON.parse(e);
      } catch (t) {
        e = null;
      } else try {
        e = JSON.parse(be(o.LsCt, e));
      } catch (t) {
        e = null;
      }
      return e || [];
    }), i(this, "zaKK", function () {
      o.storage.DJsW("_apx_od");
    }), i(this, "aJjX", function () {
      Ee.debug("Cleaning existing session data"), o.storage.DJsW("_apx_cd");
    }), i(this, "VnMy", function (e) {
      o.storage.set("_apx_cd", Se(o.LsCt, JSON.stringify(e)));
    }), i(this, "zLyf", function (e, t) {
      var n,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 3600,
          s = o.storage.get("_apx_cd"),
          a = Number(o.storage.get(I));

      if (z(a) && a > 0) {
        var u = Date.now();

        if (Math.round(le(u - Number(a))) > i) {
          var c = o.getItem(E, !0);

          if (W(c) && (W(s) && (s = o.getItem("_apx_cd", !0)), W(s))) {
            var d = s,
                f = d.chunk_details,
                l = d.chunk_meta,
                h = r({}, l, {
              id: d.session_info.id + ":" + (l.number + 1),
              number: l.number + 1,
              reporting_times: []
            });
            f = r({}, f, c), s = r({}, s, {
              chunk_meta: r({}, h),
              chunk_details: r({}, f)
            }), o.hkPh(s, !1), o.oyKR(E, null);
          }

          s = null;
        }
      }

      var g = !1;
      if (W(s)) if (ye(s)) try {
        s = JSON.parse(s);
      } catch (e) {
        s = null;
      } else try {
        s = JSON.parse(be(o.LsCt, s));
      } catch (e) {
        s = null;
      }

      if (W(s)) {
        g = !0, Ee.debug("Found session data");
        var v = s,
            p = v.chunk_meta.number,
            _ = v.session_info.id,
            m = p + 1;
        n = r({}, s, {
          chunk_meta: r({}, s.chunk_meta, {
            number: m,
            id: _ + ":" + m
          }),
          chunk_details: r({}, s.chunk_details, Ue)
        });
      } else n = function (e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
        return {
          sdk_info: {
            sdk_version: 185,
            config_id: "apx",
            tick_interval: 1,
            chunk_retry_window: 1800,
            sdk_start_time: e
          },
          session_info: {
            id: t,
            launch_time: e,
            launch_time_string: re(new Date(e)),
            startup_time: 0,
            is_background: !1,
            is_first_session: !1,
            duration: 0,
            total_duration: 0,
            process_name: "",
            is_fatal: !1,
            launch_type: "normal"
          },
          app_info: {
            app_name: "",
            app_version: "ALL",
            bundle_id: "",
            installation_time: oe(),
            app_mode: "production"
          },
          device_info: {
            id: "",
            hardware_model: "Desktop",
            dimensions: {
              height: 0,
              width: 0
            },
            os_version: "Linux x86",
            platform: "web",
            dpi: 1,
            dimensions_in_pixels: {
              height: 0,
              width: 0
            }
          },
          chunk_meta: {
            id: t + ":" + n,
            number: n,
            reporting_times: []
          },
          chunk_details: r({}, Ue, {
            user_attributes: {},
            session_attributes: {}
          })
        };
      }(e, t);

      return {
        is_new_session: !g,
        chunk: n
      };
    }), i(this, "eSLF", function () {
      var e = o.storage.get("_apx_config");
      if (W(e)) if (ye(e)) try {
        e = JSON.parse(data);
      } catch (t) {
        e = null;
      } else try {
        e = JSON.parse(be(o.LsCt, data));
      } catch (t) {
        e = null;
      }
      if (W(e) && e.enable) return e;
      if (!ye(e)) try {
        var t = JSON.parse(be(o.LsCt, e));
        if (W(t)) return t;
      } catch (e) {}
      return s;
    }), i(this, "jgZS", function (e) {
      o.storage.set("_apx_config", Se(o.LsCt, JSON.stringify(e)));
    }), i(this, "oZNt", function (e, t) {
      var n = t.cookie_prefix,
          i = t.cookie_expiration;
      o.storage.set(O(n), e, i);
    }), i(this, "MnsU", function (e) {
      var t = o.storage.get(O(e));

      if (!W(t) && q.isCookieAvailable()) {
        var n = q.get(O(e));
        if (W(n)) return o.storage.set(O(e), n), n;
      }

      return t;
    }), i(this, "nJJx", function (e, t) {
      var n = t.cookie_prefix,
          i = t.cookie_expiration;
      o.storage.set(J(n), e, i);
    }), i(this, "BlLG", function (e, t) {
      var n = e.cookie_prefix,
          i = o.storage.get(J(n));
      if (Ee.debug("Stored installation time", i), W(i)) return Number(i);

      if (q.isCookieAvailable()) {
        var r = q.get(J(n));
        if (W(r)) return o.storage.set(J(n), r), Number(r);
      }

      return ae(function () {
        return o.nJJx(t, e);
      }), t;
    }), i(this, "qddJ", function (e, t) {
      var n = t.cookie_prefix;
      o.storage.set(C(n), e);
    }), i(this, "Ukef", function (e) {
      var t = o.storage.get(C(e));

      if (!W(t) && q.isCookieAvailable()) {
        var n = q.get(C(e));
        if (W(n)) return o.storage.set(C(e), n), n;
      }

      return t;
    }), i(this, "oyKR", function (e, t) {
      o.storage.set(e, t);
    }), i(this, "getItem", function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          n = o.storage.get(e);
      if (t && W(n)) if (ye(n)) try {
        n = JSON.parse(n);
      } catch (e) {
        n = null;
      } else try {
        n = JSON.parse(be(o.LsCt, n));
      } catch (e) {
        n = null;
      }
      return n;
    }), i(this, "CalJ", function (e) {
      o.storage.clear(e);
    }), this.LsCt = n, this.storage = new qe("localStorage"), Ee.debug("DataManager initialized");
  },
      Qe = ["scroll", "touchmove"],
      Be = function t(n) {
    var o = this,
        s = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    e(this, t), i(this, "jGGs", !0), i(this, "akxD", function (e) {
      var t = e.auto_track_events;
      (void 0 === t ? [] : t).forEach(function (e) {
        if (Ee.debug("Registering for event ", e), Qe.includes(e)) o.tPiy();else {
          var t = function t(e) {
            var t = Je(e, window.location.pathname, We.getInstance().getTime());
            t.event_view = o.CiPh(e.target), We.getInstance().dispatchEvent(U, t);
          };

          o._handlers.push(o.Nlny(e, t)), ne(window, e, t);
        }
      });
    }), i(this, "bSlO", function () {
      Ee.debug("Registering for System Event ", "visibilitychange");

      var e = function e(_e2) {
        var t = We.getInstance().getTime(),
            n = window.document.visibilityState === T,
            i = Ce(window.document.visibilityState, t);

        if (n ? o.wpkU > -1 && (i.background_time = he(le(Date.now() - o.wpkU))) : o.wpkU = Date.now(), We.getInstance().dispatchEvent(j, i), n) {
          var r = We.getInstance().sOwo.apx_browser;
          !o.jGGs || -1 !== r.indexOf("Mobile Safari") && -1 !== r.indexOf("Safari") || (o.jGGs = !1);
        } else We.getInstance().AlUH();
      };

      ne(document, "visibilitychange", e), o._handlers.push(o.Nlny("visibilitychange", e));
    }), i(this, "oxHZ", function () {
      o._handlers.forEach(function (e) {
        var t = e.type,
            n = e.handler;
        Ee.debug("Unregistering from event type ", t), Qe.includes(t) ? ie(window.document, t, n) : ie(document, t, n);
      }), o._handlers = [], o._scrollEvents = [], o._scrollData = {};
    }), i(this, "KeBm", function () {
      return [];
    }), i(this, "tPiy", function () {
      var e,
          t,
          n,
          i,
          s,
          a = window.document,
          u = !1,
          c = function c(a) {
        if (!u) {
          var c = window.location.pathname;
          window.requestAnimationFrame(function () {
            n = We.getInstance().getTime();
            var d = a.target;
            s = d.offsetTop ? d.offsetTop : d.activeElement.offsetTop || 0, e = d.children.length > 0 ? d.children[0] : d, t = e.getBoundingClientRect().top, i = c + o.CiPh(d), Ee.debug(a.type, t, n, a), o._scrollData.hasOwnProperty(i) ? o._scrollData[i].sequence.push({
              top: t,
              timestamp: n
            }) : o._scrollData[i] = {
              event: r({}, Je(a, c, n), {
                elementOffsetTop: s
              }),
              sequence: [{
                top: t,
                timestamp: n
              }]
            }, u = !1;
          }), u = !0;
        }
      };

      Qe.forEach(function (e) {
        o._handlers.push(o.Nlny(e, c)), ne(a, e, c, !0);
      });
    }), i(this, "CiPh", function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.localName,
          n = void 0 === t ? "" : t,
          i = e.id,
          r = void 0 === i ? "" : i,
          s = e.className,
          a = void 0 === s ? "" : s,
          u = e.nodeName,
          c = void 0 === u ? "" : u,
          d = n && n.length > 0 ? n : c;
      if (e.hasAttribute && e.hasAttribute("name")) return "[name=".concat(e.getAttribute("name"), "]");

      if ("img" === d && e.hasAttribute && e.hasAttribute("alt") && e.hasAttribute("src")) {
        var f = e.src ? e.src : "Unknown src";
        return "img > ".concat(e.alt, " - ").concat(f);
      }

      if (r.length > 0) return "".concat(d, "#").concat(r, " > ").concat(e.innerText);
      var l = "".concat(d).concat(a && a.length > 0 ? "." + a.trim().split(" ").join(".") : "");
      return e.parentElement ? o.CiPh(e.parentElement) + " > " + l : l;
    }), i(this, "Nlny", function (e, t) {
      return {
        type: e,
        handler: t
      };
    }), this.wpkU = -1, this._handlers = [], this._scrollEvents = [], this._scrollData = {}, this.akxD(n), this.jGGs = s, this.bSlO();
  },
      Ze = function t() {
    var n = this;
    e(this, t), i(this, "nQAK", !0), i(this, "LsCt", ""), i(this, "initialize", function (e, t) {
      n.LsCt = t, e.hasOwnProperty("validate_hash") && (n.nQAK = e.validate_hash), We.getInstance().registerForEvent(X, function (e) {
        n.NUmb(e.name);
      });
    }), i(this, "fetchConfiguration", function (e, t, i, r) {
      K(r) && (n.nQAK ? We.getInstance().nsQl(t, function (t) {
        n.Dekx(t.hash, e, i, r);
      }, function () {
        Ee.error("Failed to fetch"), r({
          configs: []
        });
      }) : n.FoYS(e, i, r));
    }), i(this, "Dekx", function (e, t, i, r) {
      var o = We.getInstance().getFromStorage("_apx_sc", !0);
      W(o) || (o = {});
      var s = t + ".h";

      if (W(o[s]) && o[s] === e) {
        var a = o[t];
        return W(a) && (Array.isArray(a) || (a = [a]), Ee.debug("Reading from storage"), r({
          configs: a
        })), void We.getInstance().persistToStorage("_apx_sc", Se(n.LsCt, JSON.stringify(o)));
      }

      o[s] = e, We.getInstance().persistToStorage("_apx_sc", Se(n.LsCt, JSON.stringify(o))), n.FoYS(t, i, r);
    }), i(this, "FoYS", function (e, t, i) {
      We.getInstance().nsQl(t, function (t) {
        if (W(t.configs) && Array.isArray(t.configs) && !(t.configs.length < 1)) {
          i(t);
          var r = We.getInstance().getFromStorage("_apx_sc", !0);
          W(r) || (r = {}), r[e] = t.configs, We.getInstance().persistToStorage("_apx_sc", Se(n.LsCt, JSON.stringify(r)));
        }
      }, function () {
        i({
          configs: []
        });
      });
    }), i(this, "SZcc", function (e) {
      n.NUmb(e);
    }), i(this, "NUmb", function (e) {
      var t = We.getInstance().getFromStorage("_apx_sc", !0);
      if (W(t) || (t = {}), W(t.d) || (t.d = {}), JSON.stringify(t.d).length > 2097152) Ee.error("Reached maximum limit. Can't store further");else {
        var i = 0;
        W(t.d[e]) && (i = t.d[e]), i += 1, t.d[e] = i, We.getInstance().persistToStorage("_apx_sc", Se(n.LsCt, JSON.stringify(t)));
      }
    }), i(this, "getEventCount", function (e) {
      var t = We.getInstance().getFromStorage("_apx_sc", !0);
      return W(t) && W(t.d) && W(t.d[e]) ? t.d[e] : 0;
    });
  },
      Ve = function Ve() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    return function () {
      Ee.error("".concat(e, ": Apxor SDK not initialised."));
    };
  },
      Re = {
    logEvent: Ve("logEvent"),
    logPageView: Ve("logPageView"),
    setUserId: Ve("setUserId"),
    setUserProperties: Ve("setUserProperties"),
    setSessionProperties: Ve("setSessionProperties"),
    setAppVersion: Ve("setAppVersion"),
    getClientId: Ve("getClientId"),
    getSessionId: Ve("getSessionId"),
    startSession: Ve("startSession"),
    endSession: Ve("endSession"),
    flattenJSON: Ve("flattenJSON")
  },
      We = function () {
    function t() {
      var n = this;
      return e(this, t), i(this, "nxtJ", {}), i(this, "hmei", !1), i(this, "hfXh", {}), i(this, "FtGM", {}), i(this, "WNpk", {}), i(this, "jidY", {}), i(this, "sOwo", {}), i(this, "XWEb", {}), i(this, "htDJ", {}), i(this, "nXrS", 1), i(this, "jifn", null), i(this, "sFcS", !1), i(this, "asfZ", !1), i(this, "xQxM", {}), i(this, "xcpZ", {}), i(this, "XABq", {}), i(this, "AgLV", {}), i(this, "yNhi", 3600), i(this, "patM", 20), i(this, "gzCg", -1), i(this, "fTqh", -1), i(this, "dUZc", 10), i(this, "GoNS", !1), i(this, "twqF", -1), i(this, "PXrX", !1), i(this, "initialize", function (e, t, i, r) {
        n.hmei || (n.window = r, n.startTime = t, n.siteId = e, n.clientConfig = i || {}, n.flvm());
      }), i(this, "logEvent", function (e, t, i) {
        if (n.hmei) {
          if (n.sFcS) {
            var r = Me(e, pe(t), i, n.getTime());
            r ? n.dispatchEvent(X, r) : Ee.debug("logEvent: invalid Event ", e, t);
          } else Ee.warn("Apxor SDK is not running");
        } else Re.logEvent();
      }), i(this, "logPageView", function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.getTime();
        if (n.hmei) {
          if (n.sFcS) {
            if (e && e.length > 0) {
              var i = he(t),
                  r = De(e, fe(n.window), 0, i);
              n.AgLV.SZcc(e), W(n.jifn) ? (n.BCMf(), n.jifn = r) : n.jifn = r, n.logEvent(F, {
                time: re(new Date()),
                navigation_id: e
              }), Ee.debug("logPageView: page view is logged ", e);
            } else Ee.warn("logPageView: pathname is empty ", e);
          } else Ee.warn("Apxor SDK is not running");
        } else Re.logPageView();
      }), i(this, "setUserId", function (e) {
        n.hmei ? n.sFcS ? V(e) || n.setUserProperties({
          custom_user_id: e
        }) : Ee.warn("Apxor SDK is not running") : Re.setUserId();
      }), i(this, "setUserProperties", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        n.hmei ? n.sFcS ? Object.keys(e).length > 0 && (n.sOwo = r({}, n.sOwo, e)) : Ee.warn("Apxor SDK is not running") : Re.setUserProperties();
      }), i(this, "setSessionProperties", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        n.hmei ? n.sFcS ? Object.keys(e).length > 0 && (n.XWEb = r({}, n.XWEb, e)) : Ee.warn("Apxor SDK is not running") : Re.setSessionProperties();
      }), i(this, "setAppVersion", function (e) {
        n.hmei ? n.sFcS || Ee.warn("Apxor SDK is not running") : Re.setAppVersion();
      }), i(this, "flattenJSON", function (e) {
        return pe(e, 2);
      }), i(this, "startNewSession", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Date.now();

        if (n.hmei) {
          if (!n.sFcS) {
            n.sessionId = se(), n.startTime = e;
            var t = n.PIHq();
            n.XABq.udPJ(), n.xQxM.VnMy(t), n.xcpZ = new Be(n.config), Ee.debug("Session Id: " + n.sessionId), n.persistToStorage(N, n.sessionId), n.sFcS = !0, Ee.debug("New session started");
          }
        } else Re.startSession();
      }), i(this, "endSession", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        if (n.hmei) {
          if (n.sFcS) {
            e || n.BCMf();
            var t = r({}, n.htDJ, {
              user_attributes: r({}, n.sOwo),
              session_attributes: r({}, n.XWEb)
            }),
                i = n.Boan(t);
            n.persistToStorage(E, null, !0), n.fTqh > 0 && n.twqF > 0 ? n.xQxM.hkPh(i, !1) : n.GNWF(i, !1), n.xQxM.aJjX(), n.XABq.udPJ(), W(n.xcpZ) && n.asfZ && n.xcpZ.oxHZ(), te(document), n.sFcS = !1, Ee.debug("Current session ended");
          } else Ee.warn("Apxor SDK is not running. Please make sure to call 'startSession'");
        } else Re.endSession();
      }), i(this, "getSessionId", function () {
        return n.sessionId;
      }), i(this, "ZynQ", function () {
        return n.hmei ? n.sFcS ? n._deviceId : (Ee.warn("Apxor SDK is not running"), null) : (Re.getClientId(), null);
      }), i(this, "registerForEvent", function (e, t) {
        n.nxtJ.registerForEvent(e, t);
      }), i(this, "unregisterFromEvent", function (e, t) {
        n.nxtJ.unregisterFromEvent(e, t);
      }), i(this, "getTime", function () {
        return le(Date.now() - n.startTime);
      }), i(this, "gWEg", function () {
        var e = n.htDJ,
            t = e.app_events,
            i = e.navigation_events;

        if (t.length + i.length > 0) {
          var o = n.Boan(n.htDJ);
          n.htDJ = r({}, Ue), n.persistToStorage(E, Se(n.siteId, JSON.stringify(n.htDJ))), n.xjjw(o, !1);
        }
      }), i(this, "dispatchEvent", function (e, i) {
        var o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        Ee.debug("Dispatching Event: ", e, o);
        var s = n.xQxM.MnsU("_apx_");
        W(s) && s === n.FtGM.id || (n.xQxM.oZNt(n.FtGM.id, n.config), n.xQxM.qddJ(n.hfXh.app_version, n.config), n.xQxM.nJJx(n.startTime, n.config), n.persistToStorage(A, Se(n.siteId, JSON.stringify(n.sOwo))));
        var a = n.htDJ,
            u = a.app_events,
            c = (a.system_events, a.navigation_events);
        a.user_events;

        switch (e) {
          case X:
            n.htDJ = r({}, n.htDJ, {
              app_events: [].concat(u, i)
            });
            break;

          case j:
            n.PYwj();
            break;

          case L:
            n.htDJ = r({}, n.htDJ, {
              navigation_events: [].concat(c, i)
            });
            break;

          case U:
            n.PYwj();
        }

        if (n.nxtJ.OmvQ(e, i), e === X) {
          var d = Date.now(),
              f = n.getFromStorage(I);
          if (f = Number(f), n.persistToStorage(I, Date.now()), z(f) && f > 0 && Math.round(le(d - f)) > n.yNhi) return t.getInstance().endSession(!0), void t.getInstance().startNewSession(Date.now());
        }

        var l = r({}, n.htDJ, {
          user_attributes: r({}, n.sOwo),
          session_attributes: r({}, n.XWEb)
        }),
            h = n.Boan(l, e);
        n.persistToStorage(E, Se(n.siteId, JSON.stringify(l))), o || e !== X || n.PXrX || n.xjjw(h, o);
      }), i(this, "persistToStorage", function (e, t) {
        var i = t;
        arguments.length > 2 && void 0 !== arguments[2] && arguments[2] && ye(i) && (i = Se(n.siteId, JSON.stringify(i))), n.xQxM.oyKR(e, i);
      }), i(this, "getFromStorage", function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return n.xQxM.getItem(e, t);
      }), i(this, "GSAX", function () {
        return n.jidY;
      }), i(this, "emdp", function () {
        n.PIHq();
      }), i(this, "getUserAttributes", function () {
        return n.sOwo;
      }), i(this, "getSessionAttributes", function () {
        return n.XWEb;
      }), i(this, "nsQl", function (e, t, i) {
        n._api.nsQl(e, t, i);
      }), i(this, "fetchConfiguration", function (e, t, i, r) {
        n.AgLV.fetchConfiguration(e, t, i, r);
      }), i(this, "flvm", function () {
        try {
          Ee.info("Controller initializing with client config", n.clientConfig), n.newSession = !0, n.sessionId = se(), n.nxtJ = new Pe(), n.xQxM = new Ge(n.siteId), n.AgLV = new Ze(), n.AFXJ(n.xQxM.eSLF()), n.AgLV.initialize(n.config, n.siteId);
          var e = n.getFromStorage(A, !1);
          if (W(e)) if (Ee.debug("Retrieved Stored User attributes"), ye(e)) n.sOwo = r({}, n.sOwo, JSON.parse(e));else {
            var t = {};

            try {
              t = JSON.parse(be(n.siteId, e));
            } catch (e) {}

            n.sOwo = r({}, n.sOwo, t);
          }
          var i = n.config.idle_time_out,
              o = n.getFromStorage(M(n.config.cookie_prefix)),
              s = le(n.startTime - Number(o));
          W(o) && o > -1 && s > i ? (n.xQxM.aJjX(), s = 0) : (!W(o) || o < 1) && (s = 0);
          var a = n.PIHq();
          n.newSession && (s = 0);
          var u = n.config,
              c = u.max_chunk_event_count,
              d = void 0 === c ? 20 : c,
              f = u.max_sessions_in_storage,
              l = void 0 === f ? -1 : f;
          n.patM = W(d) && z(d) ? d : 20;
          var h = n.clientConfig,
              g = h.events_upload_time,
              v = h.retry_time;
          n.gzCg = W(g) && z(g) && g >= 1e3 ? g : -1, n.fTqh = W(v) && z(v) && v >= 1e3 ? v : -1, n.PXrX = g > 0, n.dUZc = W(l) && z(l) && l > 0 ? l : -1;
          var p = n.jidY,
              _ = p.total_duration,
              m = p.duration,
              w = s + (_ > m ? _ - m : 0);
          if (n.XABq = new Xe(n.config, w), n._api = new Le(n.siteId, n.config, n.window), n.WsHl(n.config), n.xQxM.VnMy(a), Ee.debug("Session Id: " + n.sessionId), n.persistToStorage(N, n.sessionId), n.sFcS = !0, n.hmei = !0, setTimeout(function () {
            var e = n.config.plugins;
            if (W(e) && W(e.length)) for (var t = 0; t < e.length; t++) {
              var i = e[t];

              try {
                window[i].init(), Ee.info("Initialized plugin: ", i);
              } catch (e) {
                Ee.error("Failed to initialize plugin: " + i);
              }
            }
          }, 1e3), n.PXrX) try {
            setInterval(n.sendChunkIfNeeded, n.gzCg);
          } catch (e) {}
        } catch (e) {
          Ee.error("Failed to initialize SDK: ", e), n.hmei = !1;
        }
      }), i(this, "AFXJ", function (e) {
        n.config = r({}, e, n.clientConfig);
        var t = n.config,
            i = t.max_chunk_event_count,
            o = void 0 === i ? 20 : i,
            s = t.max_sessions_in_storage,
            a = void 0 === s ? -1 : s;
        n.patM = o, n.dUZc = W(a) && z(a) && a > 0 ? a : -1, Ee.debug("Config updated");
      }), i(this, "PIHq", function () {
        var e = n.xQxM.zLyf(n.startTime, n.sessionId, n.config.idle_time_out),
            t = e.chunk;
        n.newSession = e.is_new_session;
        var i = t.session_info,
            o = t.device_info,
            s = t.app_info,
            a = t.sdk_info,
            u = t.chunk_details,
            c = t.chunk_meta;
        n.jidY = i, n.WNpk = a, n.hfXh = s, n.FtGM = o, n.htDJ = u, n.gVmK();
        var d = c.number;
        n.nXrS = d;
        var f = u.session_attributes,
            l = u.user_attributes;
        n.sOwo = r({}, n.sOwo, l), n.XWEb = r({}, n.XWEb, f), n.RkZD(), n.JmoE();
        var h = n.config.name;
        n.hfXh.app_name = W(h) ? h : "";
        var g,
            v = n.config.domain;
        if (n.hfXh.bundle_id = W(v) ? v : "", console.log("APP VERSION: " + n.clientConfig.version), W(n.clientConfig.version)) g = "" + n.clientConfig.version, n.xQxM.qddJ(g, n.config);else {
          var p = n.xQxM.Ukef(n.config.cookie_prefix);
          g = W(p) ? p : "ALL";
        }

        if (n.hfXh.app_version = g, !e.is_new_session) {
          var _ = t.session_info.id,
              m = t.session_info.launch_time;
          n.sessionId = _, n.startTime = m;
        }

        var w = {
          id: n.sessionId + ":" + n.nXrS,
          number: n.nXrS,
          reporting_times: [Date.now()]
        };
        return {
          sdk_info: n.WNpk,
          session_info: n.jidY,
          app_info: n.hfXh,
          device_info: n.FtGM,
          chunk_meta: w,
          chunk_details: n.htDJ
        };
      }), i(this, "WsHl", function (e) {
        var t = n.WNpk.sdk_version,
            i = {
          sdk_version: JSON.stringify(t),
          app_info: n.hfXh,
          device_info: n.FtGM,
          user_attributes: n.sOwo
        };

        n._api.Ypno(i, function (e) {
          Ee.debug("Fetch new config"), n.xQxM.jgZS(e), n.AFXJ(e), n.JmoE(), n.pmNw(e);
          var t = n.config.idle_time_out,
              i = void 0 === t ? 3600 : t;
          n.yNhi = z(i) ? i : 3600;
        }, function (t) {
          0 !== t && (Ee.error("Failed to fetch config"), n.pmNw(e));
        });
      }), i(this, "pmNw", function (e) {
        if (e.enable || W(e.details) && e.details.enable) {
          Ee.debug("Monitoring started...");
          var t = Ce(n.window.document.visibilityState, n.getTime());
          n.dispatchEvent(j, t), n.logPageView(n.window.location.pathname, n.getTime()), n.newSession && n.logEvent(D, {
            time: re(new Date(n.startTime))
          }), n.GCAu(), n.GjhW(), n.gWEg();
        }
      }), i(this, "GjhW", function () {
        ae(function () {
          Ee.debug("Checking for previous data:");
          var e = n.xQxM.kkGE();

          if (W(e) && Array.isArray(e) && e.length > 0) {
            Ee.debug("Found old data");

            var t = [],
                i = function i() {
              0 === (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0) && (t.length > 0 ? (Ee.debug("Failed to report previous data:"), n.xQxM.hkPh(t, !0)) : (Ee.debug("Removing transient data"), n.xQxM.zaKK()));
            };

            if (n.dUZc > 0) {
              var s = [];
              if (e.forEach(function (e) {
                var t = e.session_info.launch_time;
                -1 === s.indexOf(t) && s.push(t);
              }), s.sort(), s.length > n.dUZc) for (var a = s.length - n.dUZc, u = function u(t) {
                var n = s[t];
                e.filter(function (e) {
                  return e.session_info.launch_time !== n;
                });
              }, c = 0; c < a; c++) {
                u(c);
              }
            }

            var d = {};
            e.forEach(function (e) {
              var t = e.session_info.id;

              if (d.hasOwnProperty(t)) {
                var n = d[t];
                (n = n.concat(e)).sort(function (e, t) {
                  return e.chunk_meta.number - t.chunk_meta.number;
                }), d[t] = n;
              } else d[t] = [e];
            });
            var f = [];
            Object.keys(d).forEach(function (e) {
              if (d.hasOwnProperty(e)) {
                var t = d[e],
                    i = t[t.length - 1];
                t.forEach(function (e) {
                  var t, n, s, a;
                  e.chunk_meta.id !== i.chunk_meta.id && (i.chunk_details = r({}, i.chunk_details, {
                    app_events: (t = []).concat.apply(t, [e.chunk_details.app_events].concat(o(i.chunk_details.app_events))),
                    system_events: (n = []).concat.apply(n, [e.chunk_details.system_events].concat(o(i.chunk_details.system_events))),
                    navigation_events: (s = []).concat.apply(s, [e.chunk_details.navigation_events].concat(o(i.chunk_details.navigation_events))),
                    user_events: (a = []).concat.apply(a, [e.chunk_details.user_events].concat(o(i.chunk_details.user_events)))
                  }));
                });
                var s = [];

                if (JSON.stringify(i).length > 3145728) {
                  var a = i.chunk_details,
                      u = a.app_events,
                      c = a.user_events,
                      l = 1e5,
                      h = n.PYlV();
                  h.hasOwnProperty(e) && (l = h[e] + 1e5);
                  var g = r({}, i.chunk_meta, {
                    id: i.session_info.id + ":" + l,
                    number: l
                  }),
                      v = r({}, i.chunk_details, {
                    app_events: [],
                    user_events: []
                  }),
                      p = r({}, i, {
                    chunk_meta: r({}, g),
                    chunk_details: r({}, v)
                  });

                  if (s.push(p), l++, c.length > 0) {
                    var _ = [];
                    n.wZHy(c, 10240, _), n.QFCJ("user_events", i, s, l, _);
                  }

                  if (u.length > 0) {
                    var m = [];
                    n.wZHy(u, 10240, m), n.QFCJ("app_events", i, s, l, m);
                  }

                  f.push.apply(f, s), n.OIZV(e, l);
                } else f.push(i);
              }
            });
            var l = f.length,
                h = l,
                g = 0;
            !function e() {
              if (g < h) {
                var r = f[g];
                W(r.app_info.app_name) || (r.app_info.app_name = "", r.device_info.id = n.xQxM.MnsU("_apx_")), W(r.app_info.bundle_id) || (r.app_info.bundle_id = "", r.device_info.id = n.xQxM.MnsU("_apx_")), n._api.nHOx(r, function () {
                  i(--l), g++, e();
                }, function (o) {
                  0 !== o && (o >= 500 && n.fTqh > 0 ? setTimeout(function () {
                    e();
                  }, n.fTqh) : (413 !== o && 417 !== o && t.push(r), g++, e(), i(--l)));
                });
              }
            }();
          } else {
            var v = {};
            v[n.jidY.id] = n.nXrS, n.persistToStorage(P, Se(n.siteId, JSON.stringify(v)));
          }
        }, 1e3);
      }), i(this, "wZHy", function (e, t, n) {
        for (var i = 0, r = e.length; i < r;) {
          for (var o = [], s = 0; s < t;) {
            var a = e[i];
            if (!W(a)) break;
            s += JSON.stringify(a).length, o.push(a), i++;
          }

          n.push(o);
        }
      }), i(this, "QFCJ", function (e, t, n, i, o) {
        o.forEach(function (o) {
          var s = r({}, t.chunk_meta, {
            id: t.session_info.id + ":" + i,
            number: i
          }),
              a = r({}, Ue);
          a[e] = o;
          var u = r({}, t, {
            chunk_meta: r({}, s),
            chunk_details: r({}, a)
          });
          n.push(u), i++;
        });
      }), i(this, "hKCQ", function () {
        var e = !1;
        ee(window, function (t) {
          if (!e && n.sFcS) {
            if (e = !0, Ee.debug("Executing before unload"), window.document.visibilityState === T) {
              n.BCMf(!0);
              var i = Ce("hidden", n.getTime());
              n.dispatchEvent(j, i, !0);
            }

            if (n.PXrX) try {
              clearInterval(n.sendChunkIfNeeded);
            } catch (t) {}
            n.xcpZ.oxHZ();
          }
        });
      }), i(this, "xjjw", function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

        if (n.GoNS || n.fTqh > 0 && -1 !== n.twqF && Date.now() - n.twqF < n.fTqh) {
          var i = r({}, n.htDJ, {
            user_attributes: r({}, n.sOwo),
            session_attributes: r({}, n.XWEb)
          });
          n.persistToStorage(E, Se(n.siteId, JSON.stringify(i)));
        } else n.GoNS = !0, n.htDJ = r({}, Ue, {
          user_attributes: r({}, n.sOwo),
          session_attributes: r({}, n.XWEb)
        }), n.nXrS += 1, n.OIZV(n.jidY.id, n.nXrS), n.persistToStorage(E, Se(n.siteId, null)), n.GNWF(e, t);
      }), i(this, "GNWF", function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

        if (W(e) && W(e.chunk_details)) {
          var i = e.chunk_details,
              r = i.app_events,
              o = i.system_events,
              s = i.navigation_events,
              a = i.user_events;
          r.length < 1 && o.length < 1 && s.length < 1 && a.length < 1 ? n.GoNS = !1 : (n.persistToStorage(A, Se(n.siteId, JSON.stringify(n.sOwo))), n.xQxM.VnMy(e), W(e.app_info.app_name) || (e.app_info.app_name = "", e.device_info.id = n.xQxM.MnsU("_apx_")), W(e.app_info.bundle_id) || (e.app_info.bundle_id = "", e.device_info.id = n.xQxM.MnsU("_apx_")), t ? (n.GoNS = !1, n.xQxM.hkPh(e)) : n._api.nHOx(e, function () {
            n.GoNS = !1, n.twqF = -1, n.gVmK();
          }, function (t) {
            0 !== t && (n.GoNS = !1, t >= 500 && (n.twqF = Date.now()), 413 !== t && 417 !== t && n.xQxM.hkPh(e));
          }));
        } else n.GoNS = !1;
      }), i(this, "gVmK", function () {
        var e = n.getFromStorage(E, !0);
        W(e) && (n.htDJ = r({}, n.htDJ, e), n.persistToStorage(E, null));
      }), i(this, "PYlV", function () {
        var e = n.getFromStorage(P, !0);
        return W(e) || (e = {}), e;
      }), i(this, "OIZV", function (e, t) {
        var i = n.PYlV();
        i[e] = t, n.persistToStorage(P, Se(n.siteId, JSON.stringify(i)));
      }), i(this, "zJRN", function () {
        var e = n.config.cookie_prefix,
            t = n.clientConfig.client_id,
            i = n.xQxM.MnsU(e);

        if (!W(i)) {
          W(t) && "" !== t ? i = t : (i = se(), Ee.debug("New device Found")), n.xQxM.CalJ(n.config), n.xQxM.oZNt(i, n.config), n.xQxM.nJJx(n.startTime, n.config);
          n.jidY = r({}, n.jidY, {
            is_first_session: !0
          });
        }

        return Ee.debug("Device Id: ", i), i;
      }), i(this, "RkZD", function () {
        n._deviceId = n.zJRN();
        var e = ue(n.window),
            t = e.device,
            i = e.os,
            o = e.browser_version,
            s = e.browser,
            a = e.dimensions,
            u = e.dpi,
            c = e.dimensions_in_pixels,
            d = Fe(n._deviceId, t, a, i, u, c);
        n.FtGM = r({}, d), n.RiCZ(r({}, d, {
          browser: s,
          browser_version: o
        }));
      }), i(this, "RiCZ", function (e) {
        var t = ce(n.window, e);
        n.sOwo = r({}, n.sOwo, t);
        var i = de(n.window);
        n.XWEb = r({}, n.XWEb, i);
      }), i(this, "GCAu", function () {
        $(n.window, function () {
          n.asfZ || (n.hKCQ(), n.xcpZ = new Be(n.config, !1), n.asfZ = !0);
        });
      }), i(this, "JmoE", function () {
        var e = n.config,
            t = e.name,
            i = e.domain,
            o = e.cookie_prefix,
            s = n.xQxM.BlLG(n.config, n.startTime),
            a = ge(n.window),
            u = W(n.clientConfig.version) ? "" + n.clientConfig.version : n.xQxM.Ukef(o),
            c = Te(t, i, s, a, u);
        n.hfXh = r({}, c);
      }), i(this, "BCMf", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        W(n.jifn) && (n.jifn.duration = he(n.getTime() - n.jifn.transition_time), n.dispatchEvent(L, r({}, n.jifn), e));
      }), i(this, "AlUH", function () {
        n.BCMf(), n.jifn = null;
      }), i(this, "Boan", function (e) {
        n.PYwj();
        var t = {
          id: n.sessionId + ":" + n.nXrS,
          number: n.nXrS,
          reporting_times: [Date.now()]
        };
        return e = r({}, e, {
          user_attributes: n.sOwo,
          session_attributes: n.XWEb
        }), {
          sdk_info: n.WNpk,
          session_info: n.jidY,
          app_info: n.hfXh,
          device_info: n.FtGM,
          chunk_meta: t,
          chunk_details: e
        };
      }), i(this, "PYwj", function () {
        var e = n.getTime(),
            t = e;
        e -= n.XABq.wqDl(), n.jidY = r({}, n.jidY, {
          duration: he(e),
          total_duration: he(t)
        });
      }), i(this, "getEventCount", function (e) {
        return n.AgLV.getEventCount(e);
      }), t.instance || (t.instance = this), t.instance;
    }

    return n(t, null, [{
      key: "getInstance",
      value: function value() {
        return t.instance || (t.instance = new t()), t.instance;
      }
    }]), t;
  }();

  i(We, "instance", void 0);

  var Ke = function t(n) {
    var r = this,
        o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : oe();
    e(this, t), i(this, "hmei", !1), i(this, "Ymgg", function () {
      Array.isArray(r._q) && r._q.forEach(function (e) {
        var t = e.m,
            n = e.args;
        r.hasOwnProperty(t) && K(r[t]) && r[t].apply(r, Array.from(n));
      });
    }), i(this, "init", function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : a,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;

      try {
        if (!r.hmei) {
          W(t) && (!W(t) || t instanceof Object) || (t = a);
          var o = t,
              s = o.honorDNT,
              u = void 0 !== s && s,
              c = o.debug,
              d = void 0 !== c && c,
              f = o.events_upload_time,
              l = void 0 === f ? -1 : f,
              h = o.retry_time,
              g = void 0 === h ? -1 : h;
          if (r.GFul(d), !W(e) || !W(e.trim) || "" === e.trim()) return Ee.error("ApxorSDK couldn't be initialized: Invalid Site Id"), r._controller = Re, void (null != i && K(i) && i());
          if (u && !function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};

            if (e.navigator) {
              var t = e.navigator.doNotTrack;
              return !("1" === t || "yes" === t);
            }

            return !0;
          }(r.window)) return r._controller = Re, null != i && K(i) && i(), void Ee.error("Tracking is disabled, ApxorSDK couldn't be initialized");
          r._controller = We.getInstance(), W(l) && l > 0 && (t.events_upload_time *= 1e3), W(g) && g > 0 && (t.retry_time *= 1e3), r._controller.initialize(e, r._startTime, t, r.window), r.hmei = !0, null != n && K(n) && (Ee.debug("CLIENT_ID: " + r.getClientId()), n({
            client_id: r.getClientId(),
            session_id: r.getSessionId()
          })), r.window.console.info("ApxorSDK initialized for " + e + " with SDK version: 185");
        }
      } catch (e) {
        Ee.error("Failed to initialize Apxor SDK", e), i && K(i) && i(e);
      }
    }), i(this, "GFul", function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      Ee.enabled = e, Ee.level = "error", Ee.console = r.window.console;
    }), i(this, "logEvent", function (e, t) {
      return r._controller.logEvent(e, t);
    }), i(this, "logPageView", function (e) {
      return r._controller.logPageView(e);
    }), i(this, "setUserId", function (e) {
      return r._controller.setUserId(e);
    }), i(this, "setUserProperties", function (e) {
      return r._controller.setUserProperties(e);
    }), i(this, "setSessionProperties", function (e) {
      return r._controller.setSessionProperties(e);
    }), i(this, "setAppVersion", function (e) {
      return r._controller.setAppVersion(e);
    }), i(this, "flattenJSON", function (e) {
      return r._controller.flattenJSON(e);
    }), i(this, "getSessionId", function () {
      return r._controller.getSessionId();
    }), i(this, "getClientId", function () {
      return r._controller.ZynQ();
    }), i(this, "startNewSession", function () {
      r._controller.startNewSession(Date.now());
    }), i(this, "endSession", function () {
      r._controller.endSession();
    }), i(this, "getController", function () {
      return r._controller;
    }), this.window = n, this._startTime = o, this.Ymgg();
  };

  window.Apxor = window.Apxor || {
    _q: [],
    _st: new Date()
  }, Ke.prototype._q = window.Apxor._q;
  var Ye = new Ke(window, +window.Apxor._st);
  window.Apxor = Ye, window.ApxorLogger = Ee;

  try {
    void 0 === exports && null === exports || (exports.default = Ye, module.exports = exports.default);
  } catch (e) {}

  return Ye;
});